import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MenuStore {
  private currentPageTitle: BehaviorSubject<string> = new BehaviorSubject(null);
  private currentIsPropertySubscribed: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private isPageReadOnly: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public isNavCollapsed = false;

  constructor(private translateService: TranslateService) {
  }

  get pageTitle(): Observable<string> {
    return this.currentPageTitle.asObservable();
  }

  get isReadOnly(): Observable<boolean> {
    return this.isPageReadOnly.asObservable();
  }

  get isPropertySubscribed(): Observable<boolean> {
    return this.currentIsPropertySubscribed.asObservable();
  }

  setPageHeader(title: string, isPropertySubscribed?: boolean) {
    this.translateService.get(title).subscribe(text => this.currentPageTitle.next(text));

    if  (isPropertySubscribed !== undefined && isPropertySubscribed !== null) {
      this.currentIsPropertySubscribed.next(isPropertySubscribed);
    } else {
      this.currentIsPropertySubscribed.next(false);
    }
  }

  setIsReadOnly(readOnly: boolean) {
    this.isPageReadOnly.next(readOnly);
  }

  toggleIsNavCollapsed(): boolean {
    this.isNavCollapsed = !this.isNavCollapsed;
    return this.isNavCollapsed;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/service/menu.store.ts